export const unsupportedMark = {
  toDOM() {
    return ['span'];
  },
  excludes: '',
  attrs: {
    originalValue: {}
  }
};